import { BRANDS } from "@/lib/api";

export function BrandMarquee() {
  const items = [...BRANDS, ...BRANDS];
  return (
    <section className="marquee-group overflow-hidden border-y border-slate-200 bg-slate-50 py-6" aria-label="DPO HVAC family of brands" data-testid="brand-marquee">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((b, i) => (
          <span key={i} className="flex items-center gap-10 font-display text-lg sm:text-xl font-semibold text-slate-400">
            {b.name}
            <span className="text-ember text-xs">&#9670;</span>
          </span>
        ))}
      </div>
    </section>
  );
}
